import React from "react"
import {useRouter} from "../hooks/useRouter"

const withRouter = Component => {
    return props => {
        const {params, location, navigate} = useRouter()

        return (
            <Component
                {...props}
                router={{
                    params,
                    location,
                    navigate,
                }}
            />
        )
    }
}

export default withRouter
